import { themeUi } from '../../themeUi/themeUi';

const modules = {
  advancedCapabilitiesTitle: {
    recommendedText: {
      color: themeUi.semantic.color.text.neutral700
    },
    title: {
      color: themeUi.semantic.color.text.neutral800
    }
  },

  modulesCheckboxSelectList: {
    components: {
      searchModulePopover: {
        popoverText: {
          color: themeUi.semantic.color.text.neutral800
        },
        moduleName: {
          color: themeUi.semantic.color.text.primary600
        }
      }
    }
  }
};

export default modules;
